import "core-js/modules/es.object.assign.js";
import React from 'react';
import { renderImperatively } from '../../utils/render-imperatively';
import { MessageSharing } from './message-sharing';
/**
 * 直接打开图文消息分享浮层（指令式）
 */

export function show(props) {
  var handler = renderImperatively( /*#__PURE__*/React.createElement(MessageSharing, Object.assign({}, props)));
  return handler;
}